import { Component, Host, JSX, Prop, h } from '@stencil/core'

@Component({
    tag: 'zr-loyalty-price',
    styleUrl: 'zr-loyalty-price.scss',
    shadow: true,
})

/**
 * ZooRoyal loyalty price component.
 */
export class ZrLoyaltyPrice {

    /**
     * Loyalty price.
     */
    @Prop() loyaltyPrice: number

    /**
     * Locale for number/currency formatting.
     */
    @Prop() locale = 'de-DE'

    /**
     * Format to number.
     */
    private toPointsFormat(value: number): string {
        return new Intl.NumberFormat(this.locale, { style: 'decimal' }).format(value)
    }

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <div class={{
                    'zr-loyalty-price__wrapper': true,
                }}>
                    <p class="zr-loyalty-price__current-price">
                        {this.toPointsFormat(this.loyaltyPrice)} Punkte
                    </p>
                </div>
            </Host>
        )
    }
}
